var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _linearGradient39, _linearGradient40, _linearGradient41, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 -17 512.00019 512",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#445ea0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3216,
    stopColor: "#415a9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6926,
    stopColor: "#364d8d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2a3d7c"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 270.5995419006,
    x2: 387.0544939006,
    xlinkHref: "#a",
    y1: 264.9630272876,
    y2: 473.7786025032
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 256.000207,
    x2: 256.000207,
    y1: 474.5137745838,
    y2: 440.380526976
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2a3d7c",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3949,
    stopColor: "#273a77",
    stopOpacity: 0.396078
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8504,
    stopColor: "#1e3069",
    stopOpacity: 0.85098
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a2b63"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fffcf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#faf8f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4041,
    stopColor: "#eceef2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6353,
    stopColor: "#d5dcea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#b5c4df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a1b5d8"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 230.904164844,
    x2: 277.0340795674,
    xlinkHref: "#d",
    y1: 78.1987995864,
    y2: 339.6006122996
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 114.308161803,
    x2: 486.2439953446,
    xlinkHref: "#d",
    y1: 206.2683259888,
    y2: 578.2042599226
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1b5d8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3094,
    stopColor: "#90a2bd",
    stopOpacity: 0.309804
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7554,
    stopColor: "#7c8b9c",
    stopOpacity: 0.756863
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#748290"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: 256.000207,
    x2: 256.000207,
    xlinkHref: "#g",
    y1: 427.522294,
    y2: 453.624266
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: 257.2985793226,
    x2: 241.7376879304,
    xlinkHref: "#g",
    y1: 419.5218387976,
    y2: 315.1137500132
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    x1: 118.589387172,
    x2: 479.2871170612,
    xlinkHref: "#d",
    y1: 200.4489917236,
    y2: 561.1466212206
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientUnits: "userSpaceOnUse",
    x1: 256.000207,
    x2: 256.000207,
    xlinkHref: "#g",
    y1: 396.400712,
    y2: 424.5507852722
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    gradientTransform: "matrix(-1.003922 0 0 -1.003922 3406.640586 -573.387801)",
    gradientUnits: "userSpaceOnUse",
    x1: 3294.2031,
    x2: 3330.8052,
    xlinkHref: "#d",
    y1: -815.4185,
    y2: -778.8163
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    gradientUnits: "userSpaceOnUse",
    x1: 105.2642300738,
    x2: 22.1444076916,
    xlinkHref: "#g",
    y1: 250.9737757864,
    y2: 167.8539534042
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "n"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd00d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2378,
    stopColor: "#ffcb0e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5353,
    stopColor: "#fb1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8632,
    stopColor: "#ffa215"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9517"
  }))), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    gradientUnits: "userSpaceOnUse",
    x1: 74.0961664852,
    x2: 104.0846217238,
    xlinkHref: "#n",
    y1: 219.8056118056,
    y2: 249.7941674364
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    gradientTransform: "matrix(-1.003922 0 0 -1.003922 3406.640586 -573.387801)",
    gradientUnits: "userSpaceOnUse",
    x1: 2954.5757,
    x2: 2991.178,
    xlinkHref: "#d",
    y1: -815.4185,
    y2: -778.8163
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    gradientUnits: "userSpaceOnUse",
    x1: 451.6283632158,
    x2: 374.2228648576,
    xlinkHref: "#g",
    y1: 256.3785906578,
    y2: 178.9730922996
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    gradientUnits: "userSpaceOnUse",
    x1: 415.0554847558,
    x2: 445.0439399944,
    xlinkHref: "#n",
    y1: 219.8056118056,
    y2: 249.7941674364
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    gradientUnits: "userSpaceOnUse",
    x1: 75.3219552472,
    x2: 182.5626099546,
    xlinkHref: "#a",
    y1: 6.0692125148,
    y2: 102.5857716338
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    gradientUnits: "userSpaceOnUse",
    x1: 400.67038681,
    x2: 459.3254331898,
    xlinkHref: "#a",
    y1: 23.3123760024,
    y2: 76.101907705
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    gradientUnits: "userSpaceOnUse",
    x1: 106.376174081,
    x2: 165.0311200686,
    xlinkHref: "#a",
    y1: 132.6346629768,
    y2: 185.4241946794
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    gradientUnits: "userSpaceOnUse",
    x1: 169.623260081,
    x2: 228.2782060686,
    xlinkHref: "#a",
    y1: 132.6346629768,
    y2: 185.4241946794
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    gradientUnits: "userSpaceOnUse",
    x1: 232.870346081,
    x2: 291.5252920686,
    xlinkHref: "#a",
    y1: 132.6346629768,
    y2: 185.4241946794
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    gradientUnits: "userSpaceOnUse",
    x1: 296.117432081,
    x2: 354.7723780686,
    xlinkHref: "#a",
    y1: 132.6346629768,
    y2: 185.4241946794
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    gradientUnits: "userSpaceOnUse",
    x1: 359.364518081,
    x2: 418.0194640686,
    xlinkHref: "#a",
    y1: 132.6346629768,
    y2: 185.4241946794
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    gradientUnits: "userSpaceOnUse",
    x1: 106.376174081,
    x2: 165.0311200686,
    xlinkHref: "#a",
    y1: 184.8386069768,
    y2: 237.6281386794
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    gradientUnits: "userSpaceOnUse",
    x1: 169.623260081,
    x2: 228.2782060686,
    xlinkHref: "#a",
    y1: 184.8386069768,
    y2: 237.6281386794
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    gradientUnits: "userSpaceOnUse",
    x1: 232.870346081,
    x2: 291.5252920686,
    xlinkHref: "#a",
    y1: 184.8386069768,
    y2: 237.6281386794
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "C"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3262,
    stopColor: "#fe4672"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5324,
    stopColor: "#fb3e6c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7054,
    stopColor: "#f52f60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8591,
    stopColor: "#ee1a51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e4003d"
  }))), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    gradientUnits: "userSpaceOnUse",
    x1: 301.3692492396,
    x2: 346.68950087,
    xlinkHref: "#C",
    y1: 189.5785243076,
    y2: 230.3666704612
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    gradientUnits: "userSpaceOnUse",
    x1: 359.364518081,
    x2: 418.0194640686,
    xlinkHref: "#a",
    y1: 184.8386069768,
    y2: 237.6281386794
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    gradientUnits: "userSpaceOnUse",
    x1: 106.376174081,
    x2: 165.0311200686,
    xlinkHref: "#a",
    y1: 237.0425509768,
    y2: 289.8320826794
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    gradientUnits: "userSpaceOnUse",
    x1: 174.865740765,
    x2: 220.2077775028,
    xlinkHref: "#C",
    y1: 241.7608839846,
    y2: 282.5686066172
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    gradientUnits: "userSpaceOnUse",
    x1: 232.870346081,
    x2: 291.5252920686,
    xlinkHref: "#a",
    y1: 237.0425509768,
    y2: 289.8320826794
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    gradientUnits: "userSpaceOnUse",
    x1: 296.117432081,
    x2: 354.7723780686,
    xlinkHref: "#a",
    y1: 237.0425509768,
    y2: 289.8320826794
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    gradientUnits: "userSpaceOnUse",
    x1: 359.364518081,
    x2: 418.0194640686,
    xlinkHref: "#a",
    y1: 237.0425509768,
    y2: 289.8320826794
  })), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    gradientUnits: "userSpaceOnUse",
    x1: 106.376174081,
    x2: 165.0311200686,
    xlinkHref: "#a",
    y1: 289.2464949768,
    y2: 342.0360266794
  })), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    gradientUnits: "userSpaceOnUse",
    x1: 169.623260081,
    x2: 228.2782060686,
    xlinkHref: "#a",
    y1: 289.2464949768,
    y2: 342.0360266794
  })), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    gradientUnits: "userSpaceOnUse",
    x1: 232.870346081,
    x2: 291.5252920686,
    xlinkHref: "#a",
    y1: 289.2464949768,
    y2: 342.0360266794
  })), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "N",
    gradientUnits: "userSpaceOnUse",
    x1: 296.117432081,
    x2: 354.7723780686,
    xlinkHref: "#a",
    y1: 289.2464949768,
    y2: 342.0360266794
  })), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "O",
    gradientUnits: "userSpaceOnUse",
    x1: 364.6229611248,
    x2: 409.943112363,
    xlinkHref: "#C",
    y1: 293.979083677,
    y2: 334.7672298306
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m462.140625 477.570312h-412.28125c-6.304687 0-11.421875-5.113281-11.421875-11.421874v-454.726563c0-6.308594 5.117188-11.421875 11.421875-11.421875h412.28125c6.304687 0 11.421875 5.113281 11.421875 11.421875v454.726563c0 6.308593-5.117188 11.421874-11.421875 11.421874zm0 0",
    fill: "url(#b)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m38.4375 374.792969v91.355469c0 6.308593 5.117188 11.421874 11.421875 11.421874h412.28125c6.304687 0 11.421875-5.113281 11.421875-11.421874v-91.355469zm0 0",
    fill: "url(#c)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m462.140625 440.816406h-412.28125c-6.304687 0-11.421875-5.113281-11.421875-11.421875v-417.972656c0-6.308594 5.117188-11.421875 11.421875-11.421875h412.28125c6.304687 0 11.421875 5.113281 11.421875 11.421875v417.972656c0 6.308594-5.117188 11.421875-11.421875 11.421875zm0 0",
    fill: "url(#e)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m493.570312 440.816406h-475.140624c-5.679688 0-10.183594-5.179687-9.359376-10.769531l29.367188-198.816406h435.121094l29.367187 198.816406c.828125 5.589844-3.675781 10.769531-9.355469 10.769531zm0 0",
    fill: "url(#f)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m9.070312 430.046875c-.824218 5.589844 3.679688 10.769531 9.359376 10.769531h475.140624c5.679688 0 10.1875-5.179687 9.359376-10.769531l-11.726563-79.398437h-470.402344zm0 0",
    fill: "url(#h)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m502.929688 430.046875-11.726563-79.398437h-470.402344l-8.921875 60.476562 29.785156 29.691406h451.90625c5.679688 0 10.183594-5.179687 9.359376-10.769531zm0 0",
    fill: "url(#i)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m502.613281 411.125h-493.226562c-5.894531 0-10.332031-4.609375-9.214844-9.578125l38.265625-170.316406h435.125l38.265625 170.316406c1.117187 4.96875-3.320313 9.578125-9.214844 9.578125zm0 0",
    fill: "url(#j)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m.171875 401.546875c-1.117187 4.96875 3.320313 9.578125 9.214844 9.578125h493.226562c5.894531 0 10.332031-4.609375 9.214844-9.578125l-15.609375-69.464844h-480.4375zm0 0",
    fill: "url(#k)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m72.902344 211.8125h25.234375c1.324219 0 2.394531 1.070312 2.394531 2.394531v34.046875c0 1.320313-1.070312 2.394532-2.394531 2.394532h-25.234375c-1.320313 0-2.394532-1.074219-2.394532-2.394532v-34.046875c0-1.324219 1.074219-2.394531 2.394532-2.394531zm0 0",
    fill: "url(#l)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m117.441406 289.953125c.320313.636719.972656 1.078125 1.734375 1.078125h20.398438c1.078125 0 1.949219-.875 1.949219-1.953125v-27.988281c0-.761719-.4375-1.414063-1.074219-1.734375l-42.996094-42.996094c-.320313-.632813-.972656-1.074219-1.734375-1.074219h-20.394531c-1.082031 0-1.953125.875-1.953125 1.953125v27.988281c0 .761719.4375 1.414063 1.074218 1.734376zm0 0",
    fill: "url(#m)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m95.71875 247.175781h-20.394531c-1.082031 0-1.953125-.875-1.953125-1.953125v-27.988281c0-1.078125.875-1.953125 1.953125-1.953125h20.394531c1.078125 0 1.953125.875 1.953125 1.953125v27.988281c0 1.078125-.875 1.953125-1.953125 1.953125zm0 0",
    fill: "url(#o)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m413.863281 211.8125h25.234375c1.320313 0 2.394532 1.070312 2.394532 2.394531v34.046875c0 1.320313-1.074219 2.394532-2.394532 2.394532h-25.234375c-1.324219 0-2.394531-1.074219-2.394531-2.394532v-34.046875c0-1.324219 1.070312-2.394531 2.394531-2.394531zm0 0",
    fill: "url(#p)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m453.53125 285.085938c.320312.636718.976562 1.078124 1.734375 1.078124h20.398437c1.078126 0 1.953126-.875 1.953126-1.953124v-27.988282c0-.761718-.441407-1.414062-1.078126-1.738281l-38.125-38.125c-.324218-.636719-.976562-1.078125-1.734374-1.078125h-20.398438c-1.078125 0-1.953125.875-1.953125 1.953125v27.992187c0 .761719.441406 1.410157 1.078125 1.734376zm0 0",
    fill: "url(#q)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m436.679688 247.175781h-20.398438c-1.078125 0-1.953125-.875-1.953125-1.953125v-27.988281c0-1.078125.875-1.953125 1.953125-1.953125h20.398438c1.078124 0 1.949218.875 1.949218 1.953125v27.988281c0 1.078125-.871094 1.953125-1.949218 1.953125zm0 0",
    fill: "url(#r)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m167.007812 27.785156h-98.792968c-1.015625 0-1.839844.820313-1.839844 1.835938v29.015625c0 1.015625.824219 1.835937 1.839844 1.835937h98.792968c1.015626 0 1.835938-.820312 1.835938-1.835937v-29.015625c0-1.015625-.820312-1.835938-1.835938-1.835938zm0 0",
    fill: "url(#s)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m443.773438 27.785156h-39.945313c-1.023437 0-1.851563.820313-1.851563 1.835938v29.015625c0 1.015625.828126 1.835937 1.851563 1.835937h39.945313c1.019531 0 1.851562-.820312 1.851562-1.835937v-29.015625c0-1.015625-.832031-1.835938-1.851562-1.835938zm0 0",
    fill: "url(#t)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m149.476562 137.105469h-39.941406c-1.023437 0-1.851562.824219-1.851562 1.839843v29.015626c0 1.011718.828125 1.835937 1.851562 1.835937h39.941406c1.023438 0 1.851563-.824219 1.851563-1.835937v-29.015626c0-1.015624-.828125-1.839843-1.851563-1.839843zm0 0",
    fill: "url(#u)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m212.726562 137.105469h-39.945312c-1.023438 0-1.851562.824219-1.851562 1.839843v29.015626c0 1.011718.832031 1.835937 1.851562 1.835937h39.945312c1.023438 0 1.851563-.824219 1.851563-1.835937v-29.015626c0-1.015624-.832031-1.839843-1.851563-1.839843zm0 0",
    fill: "url(#v)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m275.972656 137.105469h-39.945312c-1.023438 0-1.851563.824219-1.851563 1.839843v29.015626c0 1.011718.832031 1.835937 1.851563 1.835937h39.945312c1.019532 0 1.851563-.824219 1.851563-1.835937v-29.015626c0-1.015624-.832031-1.839843-1.851563-1.839843zm0 0",
    fill: "url(#w)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m339.21875 137.105469h-39.945312c-1.019532 0-1.851563.824219-1.851563 1.839843v29.015626c0 1.011718.832031 1.835937 1.851563 1.835937h39.945312c1.023438 0 1.851562-.824219 1.851562-1.835937v-29.015626c0-1.015624-.828124-1.839843-1.851562-1.839843zm0 0",
    fill: "url(#x)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m402.464844 137.105469h-39.941406c-1.023438 0-1.851563.824219-1.851563 1.839843v29.015626c0 1.011718.828125 1.835937 1.851563 1.835937h39.941406c1.023437 0 1.851562-.824219 1.851562-1.835937v-29.015626c0-1.015624-.828125-1.839843-1.851562-1.839843zm0 0",
    fill: "url(#y)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m149.476562 189.3125h-39.941406c-1.023437 0-1.851562.820312-1.851562 1.835938v29.015624c0 1.011719.828125 1.835938 1.851562 1.835938h39.941406c1.023438 0 1.851563-.820312 1.851563-1.835938v-29.015624c0-1.015626-.828125-1.835938-1.851563-1.835938zm0 0",
    fill: "url(#z)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m212.726562 189.3125h-39.945312c-1.023438 0-1.851562.820312-1.851562 1.835938v29.015624c0 1.011719.832031 1.835938 1.851562 1.835938h39.945312c1.023438 0 1.851563-.820312 1.851563-1.835938v-29.015624c0-1.015626-.832031-1.835938-1.851563-1.835938zm0 0",
    fill: "url(#A)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m275.972656 189.3125h-39.945312c-1.023438 0-1.851563.820312-1.851563 1.835938v29.015624c0 1.011719.832031 1.835938 1.851563 1.835938h39.945312c1.019532 0 1.851563-.820312 1.851563-1.835938v-29.015624c0-1.015626-.832031-1.835938-1.851563-1.835938zm0 0",
    fill: "url(#B)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m324.734375 189.3125h-10.957031c-8.996094 0-16.351563 7.355469-16.351563 16.351562 0 9.019532 7.3125 16.335938 16.335938 16.335938h10.957031c8.992188 0 16.351562-7.359375 16.351562-16.351562 0-8.984376-7.351562-16.335938-16.335937-16.335938zm0 0",
    fill: "url(#D)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m402.464844 189.3125h-39.941406c-1.023438 0-1.851563.820312-1.851563 1.835938v29.015624c0 1.011719.828125 1.835938 1.851563 1.835938h39.941406c1.023437 0 1.851562-.820312 1.851562-1.835938v-29.015624c0-1.015626-.828125-1.835938-1.851562-1.835938zm0 0",
    fill: "url(#E)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m149.476562 241.515625h-39.941406c-1.023437 0-1.851562.820313-1.851562 1.835937v29.015626c0 1.015624.828125 1.835937 1.851562 1.835937h39.941406c1.023438 0 1.851563-.820313 1.851563-1.835937v-29.015626c0-1.015624-.828125-1.835937-1.851563-1.835937zm0 0",
    fill: "url(#F)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m198.238281 241.515625h-10.957031c-9.03125 0-16.351562 7.320313-16.351562 16.351563 0 9.023437 7.316406 16.335937 16.335937 16.335937h10.957031c8.996094 0 16.351563-7.359375 16.351563-16.351563.003906-9.023437-7.3125-16.335937-16.335938-16.335937zm0 0",
    fill: "url(#G)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m275.972656 241.515625h-39.945312c-1.023438 0-1.851563.820313-1.851563 1.835937v29.015626c0 1.015624.832031 1.835937 1.851563 1.835937h39.945312c1.019532 0 1.851563-.820313 1.851563-1.835937v-29.015626c0-1.015624-.832031-1.835937-1.851563-1.835937zm0 0",
    fill: "url(#H)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m339.21875 241.515625h-39.945312c-1.019532 0-1.851563.820313-1.851563 1.835937v29.015626c0 1.015624.832031 1.835937 1.851563 1.835937h39.945312c1.023438 0 1.851562-.820313 1.851562-1.835937v-29.015626c0-1.015624-.828124-1.835937-1.851562-1.835937zm0 0",
    fill: "url(#I)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m402.464844 241.515625h-39.941406c-1.023438 0-1.851563.820313-1.851563 1.835937v29.015626c0 1.015624.828125 1.835937 1.851563 1.835937h39.941406c1.023437 0 1.851562-.820313 1.851562-1.835937v-29.015626c0-1.015624-.828125-1.835937-1.851562-1.835937zm0 0",
    fill: "url(#J)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m149.476562 293.71875h-39.941406c-1.023437 0-1.851562.820312-1.851562 1.835938v29.015624c0 1.015626.828125 1.835938 1.851562 1.835938h39.941406c1.023438 0 1.851563-.820312 1.851563-1.835938v-29.015624c0-1.015626-.828125-1.835938-1.851563-1.835938zm0 0",
    fill: "url(#K)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m212.726562 293.71875h-39.945312c-1.023438 0-1.851562.820312-1.851562 1.835938v29.015624c0 1.015626.832031 1.835938 1.851562 1.835938h39.945312c1.023438 0 1.851563-.820312 1.851563-1.835938v-29.015624c0-1.015626-.832031-1.835938-1.851563-1.835938zm0 0",
    fill: "url(#L)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m275.972656 293.71875h-39.945312c-1.023438 0-1.851563.820312-1.851563 1.835938v29.015624c0 1.015626.832031 1.835938 1.851563 1.835938h39.945312c1.019532 0 1.851563-.820312 1.851563-1.835938v-29.015624c0-1.015626-.832031-1.835938-1.851563-1.835938zm0 0",
    fill: "url(#M)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m339.21875 293.71875h-39.945312c-1.019532 0-1.851563.820312-1.851563 1.835938v29.015624c0 1.015626.832031 1.835938 1.851563 1.835938h39.945312c1.023438 0 1.851562-.820312 1.851562-1.835938v-29.015624c0-1.015626-.828124-1.835938-1.851562-1.835938zm0 0",
    fill: "url(#N)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m387.980469 293.71875h-10.957031c-8.992188 0-16.351563 7.359375-16.351563 16.351562 0 9.023438 7.3125 16.335938 16.335937 16.335938h10.957032c8.992187 0 16.351562-7.359375 16.351562-16.351562 0-9.023438-7.3125-16.335938-16.335937-16.335938zm0 0",
    fill: "url(#O)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/icon-calendar.d53b353f987112a7c51ce8ae8a15828e.svg";
export { ForwardRef as ReactComponent };